import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, on } from '@ngrx/store';

import { hcmJobPostServiceFail, hcmJobPostServiceSuccess } from '@shared/invite-to-apply/store/invite-to-apply.actions';

export interface JobPostUrlEntity {
  url: string;
  jobId: number;
  error;
}

export type JobPostUrlState = EntityState<JobPostUrlEntity>;

export const jobPostUrlAdapter: EntityAdapter<JobPostUrlEntity> = createEntityAdapter<JobPostUrlEntity>({
  selectId: (element: { url: string; jobId: number; error }) => element.jobId,
});

export const initialState: JobPostUrlState = jobPostUrlAdapter.getInitialState();

export const getJobPostUrlState = createFeatureSelector<JobPostUrlState>('jobPostUrlFeatureSelector');

export const jobPostUrlReducer = createReducer(
  initialState,
  on(hcmJobPostServiceSuccess, (state, { url, jobId }) => jobPostUrlAdapter.upsertOne({ url, jobId, error: null }, state)),
  on(hcmJobPostServiceFail, (state, { error, jobId }) => jobPostUrlAdapter.upsertOne({ url: '', error, jobId }, state)),
);
